import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import {
    defaultLanguageSpecificationDashboardItem,
    LanguageSpecificationDashboardItem
} from "../LanguageSpecificationDashboardItem";
import { MappingUpdateRequest } from "./LanguageSpecificationDashboardProvider";

interface ILanguageSpecificationDashboardContext {
    languageSpecificationDashboardItem: LanguageSpecificationDashboardItem;
    isLoading: boolean;
    updateMappingItem(mapping: MappingUpdateRequest): void;
}

const initialContextState: ILanguageSpecificationDashboardContext = {
    languageSpecificationDashboardItem: defaultLanguageSpecificationDashboardItem,
    isLoading: true,
    updateMappingItem: contextFunctionInit
};

export const LanguageSpecificationDashboardContext = createContext<ILanguageSpecificationDashboardContext>(
    initialContextState
);
